import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToastService } from '@sp-client/app/services/toast.service';

@Component({
	selector: 'sp-toast',
	imports: [CommonModule],
	templateUrl: './toast.component.html',
	styleUrl: './toast.component.scss',
	animations: [
		trigger('bounceInOutMobile', [
			transition(':enter', [
				animate(
					'1s ease',
					keyframes([
						style({ transform: 'translateY(300%)' }),
						style({ transform: 'translateY(-50%)' }),
						style({ transform: 'translateY(5%)' }),
						style({ transform: 'translateY(0)' })
					])
				)
			]),
			transition(':leave', [animate('200ms', style({ transform: 'translateY(300%)' }))])
		]),
		trigger('bounceInOutDesktop', [
			transition(':enter', [
				animate(
					'1s ease',
					keyframes([
						style({ transform: 'translateY(300%)' }),
						style({ transform: 'translateY(-50%)' }),
						style({ transform: 'translateY(5%)' }),
						style({ transform: 'translateY(0)' })
					])
				)
			]),
			transition(':leave', [animate('200ms', style({ transform: 'translateY(300%)' }))])
		])
	]
})
export class ToastComponent {
	protected toastService = inject(ToastService);
}
